import { Star } from "lucide-react";

export default function Stars({ value, onChange, size = 16, testid, emptyClass = "text-amber-900/25" }) {
  return (
    <span data-testid={testid} className="inline-flex items-center gap-0.5" aria-label={`${value || 0} étoiles sur 5`}>
      {[1, 2, 3, 4, 5].map((n) => {
        const icon = <Star size={size} className={n <= Math.round(value || 0) ? "fill-honey text-honey" : emptyClass} />;
        return onChange ? (
          <button key={n} type="button" data-testid={testid && `${testid}-${n}`} onClick={() => onChange(n)} aria-label={`${n} étoile${n > 1 ? "s" : ""}`} className="p-0.5 transition-transform hover:scale-110">{icon}</button>
        ) : <span key={n}>{icon}</span>;
      })}
    </span>
  );
}
